<template>
  <div class="cfo-report-container">
    <div class="report-card">
      <div class="report-header">
        <div class="report-title-section">
          <div class="report-tag">ONE COSMO · CFO 专项报告</div>
          <div class="report-title">毛利率回升专项行动方案</div>
          <div class="report-subtitle">供应链聚焦 · 四项关差动作 · 预计追回 118.2 万</div>
        </div>
        <div class="report-info">
          <div class="report-id">CFO-2026-0622-001</div>
          <div class="report-date">2026年6月22日</div>
          <div class="report-level">密级：内部 / CFO 签发</div>
        </div>
      </div>
      <div class="report-summary">
        <div class="summary-title">执行摘要</div>
        <div class="summary-content">
          <b>结论一：</b>当前综合毛利率 17.1%，较目标 18.7% 低 1.6pct，从 Q1 的 18.0% 持续下滑 0.9pct。核心根因为 BOM 物料成本上升（62%）和采购降本兑现滞后（38%），均为供应链端因素。<br>
          <b>结论二：</b>四项关差动作预计追回毛利额 118.2 万，预测可将毛利率恢复至 18% 以上。<br>
          <b>结论三：</b>四项关差动作基于年度降本目标+大宗涨价联动对冲双向计算，采购降本与内单涨价为最高优先级动作。
        </div>
      </div>
      <div class="report-section">
        <div class="section-title">一、现状与问题</div>
        <div class="status-cards">
          <div class="status-card negative">
            <div class="status-value">18.0%→17.1%</div>
            <div class="status-label">5个月毛利率走势</div>
          </div>
          <div class="status-card warning">
            <div class="status-value">-0.9pct</div>
            <div class="status-label">累计下滑幅度</div>
          </div>
          <div class="status-card positive">
            <div class="status-value">18.0%</div>
            <div class="status-label">12周目标</div>
          </div>
        </div>
      </div>
      <div class="report-section">
        <div class="section-title">二、根因归因</div>
        <div class="attribution-table">
          <table>
            <thead>
              <tr>
                <th>归因端</th>
                <th>因素</th>
                <th>影响</th>
                <th>贡献度</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><span class="tag info">市场端</span></td>
                <td>销售降价 + 新品低毛利</td>
                <td class="negative">-564万</td>
                <td>45%</td>
              </tr>
              <tr>
                <td><span class="tag warning">采购端</span></td>
                <td>大宗涨价 + 降本兑现不足</td>
                <td class="warning">-210万</td>
                <td>25%</td>
              </tr>
              <tr>
                <td><span class="tag purple">制造端</span></td>
                <td>质量损失 + 费率抬升</td>
                <td class="purple">-266万</td>
                <td>30%</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="report-section">
        <div class="section-title">三、关差方案</div>
        <div class="gap-cards">
          <div class="gap-card">
            <div class="gap-info">
              <div class="gap-name">内单客户涨价 4%</div>
              <div class="gap-owner">销售部 · 张伟 / 7月15日</div>
            </div>
            <div class="gap-result">
              <span class="gap-value positive">+286万</span>
              <span class="gap-status normal">正常</span>
            </div>
          </div>
          <div class="gap-card">
            <div class="gap-info">
              <div class="gap-name">采购直降返利锁定</div>
              <div class="gap-owner">采购部 · 李莉 / 7月10日</div>
            </div>
            <div class="gap-result">
              <span class="gap-value positive">+246万</span>
              <span class="gap-status lag">滞后</span>
            </div>
          </div>
          <div class="gap-card">
            <div class="gap-info">
              <div class="gap-name">质量损失红线治理</div>
              <div class="gap-owner">制造部 · 王强 / 7月20日</div>
            </div>
            <div class="gap-result">
              <span class="gap-value positive">+168万</span>
              <span class="gap-status risk">风险</span>
            </div>
          </div>
          <div class="gap-card">
            <div class="gap-info">
              <div class="gap-name">制造费用重分类</div>
              <div class="gap-owner">财务部 · 赵敏 / 6月30日</div>
            </div>
            <div class="gap-result">
              <span class="gap-value positive">+112万</span>
              <span class="gap-status normal">正常</span>
            </div>
          </div>
        </div>
      </div>
      <div class="report-section">
        <div class="section-title">四、财务预测</div>
        <div class="forecast-cards">
          <div class="forecast-card negative">
            <div class="forecast-label">T 6月</div>
            <div class="forecast-value">17.1%</div>
          </div>
          <div class="forecast-card warning">
            <div class="forecast-label">T+1 7月</div>
            <div class="forecast-value">17.5%</div>
          </div>
          <div class="forecast-card positive">
            <div class="forecast-label">T+2 8月</div>
            <div class="forecast-value">17.8%</div>
          </div>
          <div class="forecast-card positive">
            <div class="forecast-label">T+3 9月</div>
            <div class="forecast-value">18.0%</div>
          </div>
        </div>
        <div class="forecast-note">假设：四项动作分月逐步兑现 · 无新增重大不利因素 · 测算模型为动作叠加法</div>
      </div>
      <div class="report-section">
        <div class="section-title">五、风险提示</div>
        <div class="risk-content">
          <b>1. 涨价谈判风险：</b>C 客户可能拒绝 4% 涨幅，需准备备选方案（降 2% + 锁定 2 年合同）。影响：若涨幅仅实现 50%，预期追回金额减少 143 万。<br>
          <b>2. 采购兑现风险：</b>MLCC 替代料验证可能延迟（供应商样品测试未完成）。影响：若延期 2 周，T+1 月毛利率仅回升至 14.8%。<br>
          <b>3. 产能恢复风险：</b>Q3 为传统淡季，利用率恢复至 85% 有不确定性。影响：若利用率始终低于 78%，固定成本持续承压。
        </div>
      </div>
      <div class="decision-section">
        <div class="decision-title">六、待 CEO 决策</div>
        <div class="decision-content">
          <b>决策 1：</b>是否批准对 C 客户的涨价方案（4%，或接受其 3% 反提案）？<br>
          <b>决策 2：</b>是否同意启动 MLCC 替代料紧急采购（预估增加初期成本 32 万，但长期可降本 180 万/年）？<br>
          <b>决策 3：</b>是否需要追加 CFO 周度跟踪汇报至 CEO 工作台？
        </div>
      </div>
      <div class="report-footer">
        <div class="footer-info">
          <b>数据来源：</b>SAP 月结数据（5月）、E2E管理口径、采购合同台账、制造费用明细表。<br>
          <b>口径说明：</b>本报告采用 E2E 管理口径（非法人口径），毛利额不含内部交易冲销。<br>
          <b>编制：</b>CFO 数字人 · ONE COSMO 智擎工作台 &nbsp;|&nbsp; <b>签发：</b>CFO 赵敏 &nbsp;|&nbsp; <b>版本：</b>v1.0
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CfoReport'
}
</script>

<style scoped>
.cfo-report-container {
  /* padding: 10px; */
  background: transparent;
  height: 100%;
  border-radius: 8px;
  overflow-y: auto;
  /* min-height: calc(100vh - 200px); */
  scrollbar-width: thin;
  scrollbar-color: #fff transparent;
}
.cfo-report-container::-webkit-scrollbar {
  width: 4px;
}
.cfo-report-container::-webkit-scrollbar-track {
  background: transparent;
}
.cfo-report-container::-webkit-scrollbar-thumb {
  background: #fff;
  border-radius: 2px;
}

.report-card {
  background: white;
  /* border: 1.5px solid rgba(74, 95, 243, 0.18); */
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 8px 32px rgba(74, 95, 243, 0.1);
  position: relative;
}

.report-card::after {
  content: '';
  position: absolute;
  top: -40px;
  right: -40px;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: rgba(74, 95, 243, 0.04);
  pointer-events: none;
}

.report-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 16px;
  border-bottom: 2px solid #4A5FF3;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 16px;
}

.report-title-section {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.report-tag {
  font-size: 10px;
  color: #94a3b8;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.report-title {
  font-size: 18px;
  font-weight: 800;
  color: #0f172a;
}

.report-subtitle {
  font-size: 12px;
  color: #64748b;
}

.report-info {
  text-align: right;
}

.report-id {
  display: inline-block;
  padding: 3px 8px;
  border-radius: 4px;
  background: rgba(74, 95, 243, 0.1);
  font-size: 10px;
  font-weight: 700;
  color: #4A5FF3;
}

.report-date {
  font-size: 10px;
  color: #94a3b8;
  margin-top: 4px;
}

.report-level {
  font-size: 10px;
  color: #94a3b8;
}

.report-summary {
  padding: 14px 16px;
  border-radius: 10px;
  background: linear-gradient(135deg, rgba(45, 127, 249, 0.06), rgba(74, 95, 243, 0.04));
  border: 1px solid rgba(45, 127, 249, 0.12);
  margin-bottom: 20px;
}

.summary-title {
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 8px;
}

.summary-content {
  font-size: 12px;
  color: #475569;
  line-height: 1.8;
}

.report-section {
  margin-bottom: 20px;
}

.section-title {
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 10px;
  padding-left: 12px;
  border-left: 3px solid #4A5FF3;
}

.status-cards {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.status-card {
  flex: 1;
  min-width: 100px;
  padding: 12px;
  border-radius: 8px;
  text-align: center;
}

.status-card.negative {
  background: #fef2f2;
}

.status-card.warning {
  background: #fff7ed;
}

.status-card.positive {
  background: #f0fdf4;
}

.status-value {
  font-size: 18px;
  font-weight: 800;
}

.status-card.negative .status-value {
  color: #e54b3d;
}

.status-card.warning .status-value {
  color: #d98213;
}

.status-card.positive .status-value {
  color: #0aa66a;
}

.status-label {
  font-size: 10px;
  color: #94a3b8;
  margin-top: 4px;
}

.attribution-table {
  overflow-x: auto;
}

.attribution-table table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.attribution-table th {
  text-align: left;
  padding: 8px 12px;
  color: #64748b;
  font-weight: 600;
  border-bottom: 1px solid #e8ecf0;
}

.attribution-table td {
  padding: 8px 12px;
  border-bottom: 1px solid #f1f5f9;
}

.tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
}

.tag.info {
  background: rgba(74, 95, 243, 0.1);
  color: #4A5FF3;
}

.tag.warning {
  background: rgba(217, 130, 19, 0.1);
  color: #d98213;
}

.tag.purple {
  background: rgba(127, 85, 217, 0.1);
  color: #7f55d9;
}

.attribution-table td.negative {
  color: #e54b3d;
  font-weight: 700;
}

.attribution-table td.warning {
  color: #d98213;
  font-weight: 700;
}

.attribution-table td.purple {
  color: #7f55d9;
  font-weight: 700;
}

.gap-cards {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.gap-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.gap-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.gap-name {
  font-size: 12px;
  font-weight: 600;
  color: #0f172a;
}

.gap-owner {
  font-size: 10px;
  color: #94a3b8;
}

.gap-result {
  display: flex;
  align-items: center;
  gap: 8px;
}

.gap-value {
  font-size: 13px;
  font-weight: 700;
}

.gap-value.positive {
  color: #0aa66a;
}

.gap-status {
  font-size: 9px;
  padding: 2px 6px;
  border-radius: 4px;
}

.gap-status.normal {
  background: rgba(10, 166, 106, 0.1);
  color: #0aa66a;
}

.gap-status.lag {
  background: rgba(217, 130, 19, 0.1);
  color: #d98213;
}

.gap-status.risk {
  background: rgba(229, 75, 61, 0.1);
  color: #e54b3d;
}

.forecast-cards {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
}

.forecast-card {
  flex: 1;
  padding: 12px;
  border-radius: 8px;
  background: #f8fafc;
  text-align: center;
}

.forecast-card.negative {
  background: #fef2f2;
}

.forecast-card.warning {
  background: #fff7ed;
}

.forecast-card.positive {
  background: #f0fdf4;
}

.forecast-label {
  font-size: 11px;
  color: #94a3b8;
  margin-bottom: 4px;
}

.forecast-value {
  font-size: 18px;
  font-weight: 800;
}

.forecast-card.negative .forecast-value {
  color: #e54b3d;
}

.forecast-card.warning .forecast-value {
  color: #d98213;
}

.forecast-card.positive .forecast-value {
  color: #0aa66a;
}

.forecast-note {
  font-size: 10px;
  color: #94a3b8;
}

.risk-content {
  font-size: 11px;
  color: #475569;
  line-height: 1.7;
}

.decision-section {
  padding: 14px 16px;
  border-radius: 10px;
  background: linear-gradient(135deg, rgba(245, 158, 11, 0.08), rgba(249, 115, 22, 0.04));
  border: 1px solid rgba(245, 158, 11, 0.2);
  margin-bottom: 20px;
}

.decision-title {
  font-size: 13px;
  font-weight: 700;
  color: #d98213;
  margin-bottom: 8px;
}

.decision-content {
  font-size: 12px;
  color: #475569;
  line-height: 1.8;
}

.report-footer {
  margin-bottom: 20px;
}

.footer-info {
  font-size: 11px;
  color: #94a3b8;
  line-height: 1.7;
}

</style>

